module.exports = __webpack_public_path__ + "img/TV_Adverts_image_2.304ab7cc.jpg";